/* eslint-disable */
export default {
  downloadSuccess: 'Registro descargado.',
  downloadFail: 'Error al descargar el registro. Vuelva a intentarlo.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
